/**
 * A collection of helper functions to calculate the child's birthday. Utilizes moment.js.
 */
 import moment from 'moment';

 /**
  * @desc Dynamic list of years based on the current year using moment for date manipulation.
  * @returns {Array} - List of 5 sequential years depending on the current year.
  */
 function getBirthdayYears() {
   const thisYear = moment().year();
   const yearMinusOne = moment().subtract(1, 'years').year();
   const yearMinusTwo = moment().subtract(2, 'years').year();
   const yearMinusThree = moment().subtract(3, 'years').year();
   const yearMinusFour = moment().subtract(4, 'years').year();

   return [yearMinusFour, yearMinusThree, yearMinusTwo, yearMinusOne,thisYear];
 }

 /**
 * @desc Generates the options for the Child Birthday Datepicker based on the years provided by `yearsList`.
 *       Originally from HolidayPay SPA. Some slight adjustments to cap the picker to current date.
 * @param {Array <Integer>} yearsList - list of years that the datepicker will show.
 * @returns {Array <Array>} - Array of arrays:
 *   [list of years],
 *   [list of months],
 *   [[days in month for that year]] -> 2021:[[jan:1:31], [feb:1:28], ...], 2020:[[jan:1:31, feb:1:29], ...], etc.
 *      Implemented like this for leap-year edge-case when allowing dynamic `yearsList` param.
 */
function getBirthdayDates(yearsList) {
    const monthsCount = Array.from(new Array(12), (x, i) => i + 1);
    var monthsList = [];
    var daysList = [];

    for (var year in yearsList) {
        var count = 1;
        var monthsInYearList = [];
        var daysInMonthList = [];
        var daysInMonthNumber;

            for (var month in monthsCount) {
                if (moment(yearsList[year] + '-' + monthsCount[month], 'YYYY-M').isBefore(moment(), 'month')) {
                    monthsInYearList.push(count)
                    count++;

                    daysInMonthNumber = moment(yearsList[year] + '-' + monthsCount[month], 'YYYY-M').daysInMonth();
                    daysInMonthList.push(Array.from(new Array(daysInMonthNumber), (x, i) => i + 1));
                } else if (moment(yearsList[year] + '-' + monthsCount[month], 'YYYY-M').isSame(moment(), 'month')) {
                    monthsInYearList.push(count);
                    count++;

                    daysInMonthNumber = moment().date();
                    daysInMonthList.push(Array.from(new Array(daysInMonthNumber), (x, i) => i + 1));
                }
            }
            daysList.push(daysInMonthList);
            monthsList.push(monthsInYearList)
    }
    return [yearsList, monthsList, daysList];
}

/**
 * @desc Converts inputs into a moment date object.
 *       Originally from HolidayPay SPA.
 * @param {String} year - year inputted [2021].
 * @param {String} month - month inputted [January].
 * @param {String} day - day inputted [1].
 * @returns {Moment} - moment date object.
 */
 function convertToMomentObject(year, month, day) {
    return moment(year + '-' + month + '-' + day, 'YYYY-M-D').format('x');
}

 export {
   getBirthdayYears,
   getBirthdayDates,
   convertToMomentObject
 }
